import { LitElement, html, css, utils } from '@hh/global.js'
const { addToCart, reRenderShopifySections, getCart } = utils

class HHAddAllToCart extends LitElement {
  static properties = {
    variantIds: {
      type: Array,
      converter: (id) => id.split(','),
      attribute: 'variant-ids',
    },
    showMiniCartAfterSubmission: {
      type: Boolean,
      attribute: 'show-mini-cart',
    },
    loading: {
      type: Boolean,
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  updated(changedProperties) {
    if (changedProperties.has('loading')) {
      this.toggleButtonLoading()
    }
  }

  async onClick(e) {
    e.preventDefault()
    if (this.variantIds.length === 0) return
    this.loading = true

    const someMaxQuantity = await this.checkMaxQuantity()

    if (someMaxQuantity) {
      this.dispatchEvent(
        new CustomEvent('productError', {
          bubbles: true,
          composed: true,
          detail: {
            id: 'error-notification',
            auto_close: 2500,
          },
        })
      )
      this.loading = false
    } else {
      await this.addAllToCart()
    }
  }

  async addAllToCart() {
    const items = this.variantIds
      .filter((id) => id)
      .map((id) => ({ id }))
      .reverse()

    try {
      await reRenderShopifySections(await addToCart({ items }))

      if (this.showMiniCartAfterSubmission) {
        utils.toggle(document.body, ['mini-cart-is-active'])
      }

      this.dispatchEvent(
        new CustomEvent('productAdded', {
          bubbles: true,
          composed: true,
          detail: {
            id: 'cart-notification',
            auto_close: 2500,
          },
        })
      )

      window.dispatchEvent(
        new CustomEvent('cart-message:added-all', {
          bubbles: true,
          composed: true,
        })
      )
    } catch (error) {
      console.error(error)
    } finally {
      this.loading = false
    }
  }

  toggleButtonLoading() {
    if (!this.button) return
    if (this.loading) {
      this.button.setAttribute('loading', '')
      this.button.setAttribute('disabled', '')
    } else {
      this.button.removeAttribute('loading')
      this.button.removeAttribute('disabled')
    }
  }

  async checkMaxQuantity() {
    const cart = await getCart()
    const { items } = cart
    const { cartMaxQuantity } = window.themeSettings

    const variantIds = this.variantIds.map((id) => parseInt(id))
    const matchingCartItems = items.filter((item) =>
      variantIds.includes(item.id)
    )
    if (matchingCartItems.length === 0) return false

    const someMaxQuantity = matchingCartItems.some(
      (item) => item.quantity >= cartMaxQuantity
    )

    if (someMaxQuantity) {
      return true
    }
    return false
  }

  get button() {
    return this.querySelector('hh-button') ?? null
  }

  render() {
    return html`<slot name="button" @click=${this.onClick}></slot>`
  }

  static styles = css``
}

customElements.define('hh-add-all-to-cart', HHAddAllToCart)
